module.exports = __webpack_public_path__ + "img/e.e6aeb344.jpg";